import React, { Component } from "react";
import ContentBody from "../components/ContentBody";
import PageHeader from "../components/PageHeader";
import Email from "../components/Email";
import Language from "../utils/Language";

import styles from "./PageLegalDisclosure.module.css";

class PageLegalDisclosure extends Component {
  render() {
    const info = require("../constants/legal_disclosure.json");
    let selected = Language.GetLangId();
    if (selected >= info.languages.length) selected = 0;
    const { name, description } = info.languages[selected];

    const parts = description.split("{{email}}");

    return (
      <ContentBody>
        <PageHeader title={name} eyebrow={Language.GetString("footer_legal")} />

        <div className={styles.Prose}>
          <div className={styles.ImpressumBlock}>
            {parts.map((part, i) => (
              <React.Fragment key={i}>
                {part}
                {i < parts.length - 1 && <Email />}
              </React.Fragment>
            ))}
          </div>

          <h2>Datenschutzerklärung (DSGVO)</h2>
          <p>
            Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und
            Zweck der Verarbeitung von personenbezogenen Daten (nachfolgend kurz
            „Daten“) im Rahmen der Erbringung unserer Leistungen sowie innerhalb
            unseres Onlineangebotes und der mit ihm verbundenen Webseiten,
            Funktionen und Inhalte sowie externen Onlinepräsenzen, wie z.B.
            unser Social Media Profile auf (nachfolgend gemeinsam bezeichnet als
            „Onlineangebot“). Im Hinblick auf die verwendeten Begrifflichkeiten,
            wie z.B. „Verarbeitung“ oder „Verantwortlicher“ verweisen wir auf
            die Definitionen im Art. 4 der Datenschutzgrundverordnung (DSGVO).
          </p>

          <h3>Arten der verarbeiteten Daten</h3>
          <p>
            - Bestandsdaten (z.B., Personen-Stammdaten, Namen oder Adressen).
            <br />
            - Kontaktdaten (z.B., E-Mail, Telefonnummern).
            <br />
            - Inhaltsdaten (z.B., Texteingaben, Fotografien, Videos).
            <br />
            - Nutzungsdaten (z.B., besuchte Webseiten, Interesse an Inhalten,
            Zugriffszeiten).
            <br />
            - Meta-/Kommunikationsdaten (z.B., Geräte-Informationen, IP-Adressen).
          </p>

          <h3>Kategorien betroffener Personen</h3>
          <p>
            Besucher und Nutzer des Onlineangebotes (Nachfolgend bezeichnen wir
            die betroffenen Personen zusammenfassend auch als „Nutzer“).
          </p>

          <h3>Zweck der Verarbeitung</h3>
          <p>
            - Zurverfügungstellung des Onlineangebotes, seiner Funktionen und
            Inhalte.
            <br />
            - Beantwortung von Kontaktanfragen und Kommunikation mit Nutzern.
            <br />
            - Sicherheitsmaßnahmen.
            <br />
            - Reichweitenmessung/Marketing
          </p>

          <h3>Verwendete Begrifflichkeiten</h3>
          <p>
            „Personenbezogene Daten“ sind alle Informationen, die sich auf eine
            identifizierte oder identifizierbare natürliche Person beziehen.
            „Verarbeitung“ ist jeder mit oder ohne Hilfe automatisierter
            Verfahren ausgeführte Vorgang im Zusammenhang mit personenbezogenen
            Daten. „Verantwortlicher“ ist die Stelle, die über Zwecke und Mittel
            der Verarbeitung entscheidet.
          </p>

          <h3>Maßgebliche Rechtsgrundlagen</h3>
          <p>
            Nach Maßgabe des Art. 13 DSGVO teilen wir Ihnen die Rechtsgrundlagen
            unserer Datenverarbeitungen mit. Die Rechtsgrundlage für die
            Einholung von Einwilligungen ist Art. 6 Abs. 1 lit. a und Art. 7
            DSGVO; für die Verarbeitung zur Erfüllung unserer Leistungen Art. 6
            Abs. 1 lit. b DSGVO; für die Verarbeitung zur Erfüllung unserer
            rechtlichen Verpflichtungen Art. 6 Abs. 1 lit. c DSGVO; zur Wahrung
            unserer berechtigten Interessen Art. 6 Abs. 1 lit. f DSGVO.
          </p>

          <h3>Sicherheitsmaßnahmen</h3>
          <p>
            Wir treffen geeignete technische und organisatorische Maßnahmen, um
            ein dem Risiko angemessenes Schutzniveau zu gewährleisten. Dazu
            gehören insbesondere die Sicherung der Vertraulichkeit, Integrität
            und Verfügbarkeit von Daten.
          </p>

          <h3>Rechte der betroffenen Personen</h3>
          <p>
            Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob
            betreffende Daten verarbeitet werden, auf Auskunft über diese Daten,
            auf Berichtigung, Löschung und Einschränkung der Verarbeitung sowie
            auf Datenübertragbarkeit. Sie haben außerdem das Recht, eine
            Beschwerde bei der zuständigen Aufsichtsbehörde einzureichen.
          </p>

          <h3>Widerrufs- und Widerspruchsrecht</h3>
          <p>
            Sie haben das Recht, erteilte Einwilligungen mit Wirkung für die
            Zukunft zu widerrufen, und können der künftigen Verarbeitung Ihrer
            Daten jederzeit widersprechen.
          </p>

          <h3>Cookies</h3>
          <p>
            „Cookies“ sind kleine Dateien, die auf Rechnern der Nutzer
            gespeichert werden. Falls Sie nicht möchten, dass Cookies auf Ihrem
            Rechner gespeichert werden, deaktivieren Sie die entsprechende
            Option in den Systemeinstellungen Ihres Browsers. Ein genereller
            Widerspruch gegen den Einsatz von Cookies zu Onlinemarketing-Zwecken
            kann z.B. über{" "}
            <a
              href="http://www.aboutads.info/choices/"
              target="_blank"
              rel="noreferrer"
            >
              aboutads.info/choices
            </a>{" "}
            oder{" "}
            <a
              href="http://www.youronlinechoices.com/"
              target="_blank"
              rel="noreferrer"
            >
              youronlinechoices.com
            </a>{" "}
            erklärt werden.
          </p>

          <h3>Hosting und Zugriffsdaten</h3>
          <p>
            Die von uns in Anspruch genommenen Hosting-Leistungen dienen der
            Zurverfügungstellung dieses Onlineangebotes. Aus Sicherheitsgründen
            werden Serverlogfiles (Name der abgerufenen Datei, Datum, Zeit,
            Datenmenge, Browsertyp, Betriebssystem, Referrer URL, IP-Adresse)
            für die Dauer von maximal 7 Tagen gespeichert und danach gelöscht.
          </p>

          <a
            href="https://datenschutz-generator.de"
            rel="nofollow noreferrer"
            target="_blank"
            className={styles.Generator}
          >
            Erstellt mit Datenschutz-Generator.de von RA Dr. Thomas Schwenke
          </a>
        </div>
      </ContentBody>
    );
  }
}

export default PageLegalDisclosure;
